<div class="pt-4 pb-2 px-0 container-fluid d-flex justify-content-between w-100">
  <div>
    <label>CUSTOMER SEARCH: </label>
    <app-customers-search [readonly]="canSearchCustomers()"></app-customers-search>
  </div>
  <ng-container *ngIf="selectedCustomer">
    <button
      class="navlink btn"
      [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/details']"
      [ngClass]="{
        activeLink: isActive('/customers/' + selectedCustomer.customerNumber + '/details')
      }"
    >
      CUSTOMER DETAILS
    </button>
    <button
      class="navlink btn"
      [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/vehicles']"
      [ngClass]="{ activeLink: isActive('/vehicles') }"
      *ngIf="!isExternalUser"
    >
      CUSTOMER VEHICLES
    </button>
    <ng-template [ngIf]="isExternalUser">
      <button
        class="navlink btn"
        [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/invoice']"
        [ngClass]="{ activeLink: isActive('/invoice') }"
      >
        INVOICES
      </button>
      <button
        class="navlink btn"
        [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/statement']"
        [ngClass]="{ activeLink: isActive('/statement') }"
      >
        STATEMENTS
      </button>
      <button
        class="navlink btn"
        [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/showsales']"
        [ngClass]="{ activeLink: isActive('/showsales') }"
        *ngIf="hasShowSales$ | async"
      >
        SHOW SALES
      </button>
    </ng-template>
    <ng-template [ngIf]="!isExternalUser">
      <button
        class="navlink btn"
        [routerLink]="['/pos/customers/' + selectedCustomer.customerNumber + '/shipTo']"
        [ngClass]="{ activeLink: isActive('/shipTo') }"
        *ngIf="selectedCustomer.customerType === customerType.billTo"
      >
        ADD SHIP TO
      </button>
      <button class="navlink btn" [routerLink]="['/pos/orders/customer/' + selectedCustomer.customerNumber]">REVIEW ORDERS</button>
    </ng-template>
    <button *ngIf="arbCentralSecurityFunctions?.showOrderActionsTF && canStartNewOrder()" class="navlink btn" (click)="toStartNewOrder(selectedCustomer.customerNumber)">NEW ORDER</button>
  </ng-container>
  <button
    class="navlink btn"
    [routerLink]="['/pos/customers/new']"
    [ngClass]="{ activeLink: isActive('/customers/new') }"
    *ngIf="!selectedCustomer && !isExternalUser"
  >
    CREATE RETAIL CUSTOMER
  </button>
</div>
